<div class="product-request-info">
  <ng-container *ngIf="!!data || !!loading || mode === 'create'; else productRequestNotFounded">
    <lp-product-request-info-header
      [id]="data?.id"
      [mode]="mode"
      [allowedEditing]="allowEditing$ | async"
      [allowedDeleting]="allowDeleting$ | async"
      (cancelEdit)="onClickCancelButton()"
      (startEdit)="onClickEditButton.emit()"
      (startDelete)="onClickDeleteButton()"
    ></lp-product-request-info-header>

    <tui-scrollbar>
      <div class="product-request-info__content">
        <lp-product-request-view *ngIf="mode === 'view'" [data]="data" [loading]="loading"></lp-product-request-view>

        <lp-product-request-edit
          *ngIf="mode === 'edit' || mode === 'create'"
          [data]="data"
          [mode]="mode"
          [loading]="loading"
          (saveProductRequest)="onClickSaveButton($event)"
          (cancelEdit)="onClickCancelButton()"
        ></lp-product-request-edit>
      </div>
    </tui-scrollbar>
  </ng-container>
</div>

<ng-template #productRequestNotFounded>
  <div class="product-request-info__not-found">
    <span class="text_bold text_size-m">{{ 'components.lpProductRequestInfo.labels.notFound' | translate }}</span>

    <app-link
      [routerLink]="'/loyalty'"
      [displayText]="'components.loyaltyProgram.buttons.homeLink' | translate"
    ></app-link>
  </div>
</ng-template>
